export const TABLE_HEADER_HEIGHT = '36px';
